'use strict';

import SettingsController from './settings.controller';

export default angular.module('leafApp.settings', [])
  .controller('SettingsController', SettingsController)
  .name;
